module.exports = __webpack_public_path__ + "static/media/home_banner_7.0ce649dd.jpg";